import { MessageTypes } from '../constants/constants';
import _isEmpty from 'lodash/isEmpty';
export function extractTextToCopy(message) {
    switch (message.type) {
        case MessageTypes.Templates.Form: {
            var _a = message.templateData, title = _a.title, text = _a.text, fields = _a.fields;
            var fieldsText = fields.reduce(function (acc, val) { return acc.concat(getValidFieldText(val)); }, '');
            var textToCopy = "" + (_isEmpty(title) ? '' : title + "\n") + (_isEmpty(text) ? '' : text + "\n") + fieldsText;
            return textToCopy.trim();
        }
        case MessageTypes.Message:
            return message.messageParts[0].data.text;
        default:
            return null;
    }
}
function getValidFieldText(field) {
    var fieldIsValid = !_isEmpty(field.name) && !_isEmpty(field.value);
    return fieldIsValid ? field.name + "\n" + field.value + "\n" : '';
}
